<!--    Верхняя секция шапки-->
@if (userIsAgent) {
  <app-header-agent [auth]="userIsAgent"></app-header-agent>
} @else {
  <header class="__new__header">
    <app-header-top></app-header-top>
    <!-- Нижняя секция шапки    /-->
    <app-header-bottom></app-header-bottom>
    <!--    Фиксированная -->
    <app-header-fixed></app-header-fixed>
    <!--_fixedMenu-->
  </header>
}

<main class="app">
  <router-outlet></router-outlet>
  <app-email-subscription [show]="showEmailSubscription"></app-email-subscription>
</main>

@if (userIsAgent) {
  <app-footer-agent></app-footer-agent>
} @else {
  <!-- Новый мобильный футер (ряд кнопок, как в приложении). -->
  <app-footer-mobile></app-footer-mobile>
  <app-footer-primary></app-footer-primary>
}
